import { Typography } from 'antd';
import { Select } from 'components/common';
import OmiChanelChatSourceIcon from 'components/omni-channel-chat/OmiChanelChatSourceIcon';
import { useSourceOptions } from 'hooks';
import { omniChatMessages } from 'messages';
import { ComponentProps, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { FindAllRoleDto } from 'types';
import { CHAT_SESSION_SOURCE, ITEM_SELECT_ALL } from 'utils';

type OmniChannelSourceSelectProps = ComponentProps<typeof Select> &
  Omit<FindAllRoleDto, 'pageIndex' | 'pageSize' | 'keyword'> & {
    isAll?: boolean;
    allItemLabel?: string;
  };

const OmniChannelSourceSelect = ({ allItemLabel, isAll, className, ...props }: OmniChannelSourceSelectProps) => {
  const [keyword, setKeyword] = useState('');

  const { data, handleLoadMore, isLoading, isFetching, hasMore, resetPage } = useSourceOptions({
    keyword
  });
  const handleSearch = (val: string) => {
    resetPage();
    setKeyword(val);
  };
  return (
    <Select
      {...props}
      onLoadMore={handleLoadMore}
      loading={isLoading || isFetching}
      hasMore={hasMore}
      filterOption={false}
      onSearch={handleSearch}
      options={[
        ...(isAll
          ? [
              {
                ...ITEM_SELECT_ALL,
                title: allItemLabel ?? ITEM_SELECT_ALL.title,
                label: allItemLabel ?? ITEM_SELECT_ALL.title
              }
            ]
          : []),
        ...(data || []).map((itm) => ({
          ...itm,
          label: itm.name,
          value: itm.value
        }))
      ]}
      optionRender={(opt) => (
        <div className='flex max-w-full gap-2 py-[6px] 2xl:w-40'>
          {opt.value && <OmiChanelChatSourceIcon source={opt?.value as CHAT_SESSION_SOURCE} size={20} />}
          <Typography.Text ellipsis className='mb-0'>
            {opt?.label}
          </Typography.Text>
        </div>
      )}
      className={twMerge('h-10', className)}
      dropdownRender={(menu) => (
        <div>
          <div className='py-2 pl-[18px]'>
            <Typography.Text className='text-xs uppercase text-colorTextPlaceholder'>
              {omniChatMessages.channelChat}
            </Typography.Text>
          </div>

          {menu}
        </div>
      )}
    />
  );
};
export default OmniChannelSourceSelect;
